import { getActualVotesScore, getOptimisticVotesScore } from './comments-vote-utils';
export const getVoteState = (voteState) => {
    if (voteState.currentUserVote.pendingState) {
        // We are optimistic!
        return {
            pending: true,
            score: getOptimisticVotesScore(voteState),
            state: voteState.currentUserVote.pendingState,
        };
    }
    return {
        pending: false,
        score: getActualVotesScore(voteState),
        state: voteState.currentUserVote.type,
    };
};
//# sourceMappingURL=comments-vote-selectors.js.map